module.exports = __webpack_public_path__ + "media/images/badge-trotter@2x-bea1394a05213323b6ab918b1d86e365.png";